import * as React from 'react';
import s from './NotFound.scss';
import { Text } from '@wix/design-system';
const NotFound = ({ headerText, messageText }) => (React.createElement("div", { className: s.notFound },
    React.createElement("div", { className: s.notFoundContent },
        React.createElement(Text, { className: s.notFoundHeader, weight: "bold", size: "tiny", dataHook: "not-found-header-text" }, headerText),
        React.createElement(Text, { weight: "thin", className: s.notFoundMessage, size: "medium", dataHook: "not-found-message-text" }, messageText))));
export default NotFound;
//# sourceMappingURL=NotFound.js.map